import React, { FC, memo, useState } from 'react';
import placeholder from '@/public/img/PlaceholderImage.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LoadImage from '@/public/img/LoadImage.png';

type Props = {
  src?: any;
  alt?: any;
  className?: string;
  width?: any;
  height?: any;
}

const LazyImage: FC<Props> = memo((props) => {
  return (
    <LazyLoadImage src={props.src || placeholder.src}
                   className={props.className}
                   width={props.width}
                   height={props.height}
                   placeholderSrc={LoadImage.src}
                   alt={props.alt}
                   loading="lazy"
                   decoding="async"
                   style={{ display: 'block' }}
    />
  )
});

export default LazyImage;
